var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaginationArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m15.698 11.191-5.311-5.85A.93.93 0 0 0 9.654 5a.93.93 0 0 0-.734.341l-.618.674Q8 6.348 8 6.825c0 .317.1.583.302.817L12.26 12 8.3 16.368a1.16 1.16 0 0 0-.301.808c0 .318.1.584.301.818l.62.674q.3.332.733.332.432 0 .733-.332l5.311-5.85q.303-.35.302-.818 0-.476-.302-.809"
})));
export default SvgPaginationArrowRight;